import "core-js/modules/es6.string.trim";
import "core-js/modules/es6.array.map";
import "core-js/modules/es6.function.name";
import _classCallCheck from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/createClass";
export var Parameters;

(function (Parameters) {
  var defaultValue = '';

  var QueryParameter =
  /*#__PURE__*/
  function () {
    /**
     * Parameter
     * @constructor
     * @param {string} name - Name of the parameter
     * @param {string} value - Value of the parameter
     */
    function QueryParameter(name, value) {
      _classCallCheck(this, QueryParameter);

      this.name = name;
      this.value = value;

      if (!name) {
        throw Error("Name of the parameter is not specified");
      }
    }

    _createClass(QueryParameter, [{
      key: "getParam",
      value: function getParam() {
        return "".concat(this.name, "=").concat(this.value);
      }
    }]);

    return QueryParameter;
  }();

  Parameters.QueryParameter = QueryParameter;

  var ElementsParameter =
  /*#__PURE__*/
  function () {
    /**
     * Sets elements (projection) so that only certain elements from a content item are returned
     * @constructor
     * @param {string[]} elementCodenames - Array of element codenames to include in response.
     */
    function ElementsParameter(elementCodenames) {
      _classCallCheck(this, ElementsParameter);

      this.elementCodenames = elementCodenames;
    }

    _createClass(ElementsParameter, [{
      key: "getParam",
      value: function getParam() {
        return "elements=".concat(this.getParamValue());
      }
    }, {
      key: "getParamValue",
      value: function getParamValue() {
        if (!this.elementCodenames) {
          return defaultValue;
        }

        return this.elementCodenames.map(function (m) {
          if (!m) {
            throw Error("Codename of 'ElementsParameter' cannot be null or empty");
          }

          return m.trim();
        }).join(',');
      }
    }]);

    return ElementsParameter;
  }();

  Parameters.ElementsParameter = ElementsParameter;

  var LimitParameter =
  /*#__PURE__*/
  function () {
    /**
     * Limits the number of items that are returned from response
     * @constructor
     * @param {number} limit - Number of elements that will be returned
     */
    function LimitParameter(limit) {
      _classCallCheck(this, LimitParameter);

      this.limit = limit;

      if (limit <= 0) {
        throw Error("'LimitParameter' must specify a positive integer");
      }
    }

    _createClass(LimitParameter, [{
      key: "getParam",
      value: function getParam() {
        return "limit=".concat(this.limit);
      }
    }]);

    return LimitParameter;
  }();

  Parameters.LimitParameter = LimitParameter;

  var IncludeTotalCountParameter =
  /*#__PURE__*/
  function () {
    /**
     * Adds 'includeTotalCount' query parameter to query
     * @constructor
     */
    function IncludeTotalCountParameter() {
      _classCallCheck(this, IncludeTotalCountParameter);
    }

    _createClass(IncludeTotalCountParameter, [{
      key: "getParam",
      value: function getParam() {
        return "includeTotalCount=true";
      }
    }]);

    return IncludeTotalCountParameter;
  }();

  Parameters.IncludeTotalCountParameter = IncludeTotalCountParameter;

  var SkipParameter =
  /*#__PURE__*/
  function () {
    /**
     * Configures response to skip certain number of items
     * @constructor
     * @param {number} skip - Number of content items that will be skipped
     */
    function SkipParameter(skip) {
      _classCallCheck(this, SkipParameter);

      this.skip = skip;

      if (skip < 0) {
        throw Error("'SkipParameter' must specify a positive integer number or zero.\"");
      }
    }

    _createClass(SkipParameter, [{
      key: "getParam",
      value: function getParam() {
        return "skip=".concat(this.skip);
      }
    }]);

    return SkipParameter;
  }();

  Parameters.SkipParameter = SkipParameter;

  var OrderParameter =
  /*#__PURE__*/
  function () {
    /**
     * Sorts the response based on given element.
     * @constructor
     * @param {string} element - Element that will be used for sorting (can be both elements.<elementname> or system.<elementname>)
     * @param {SortOrder} sortOrder - Order type (desc/asc). Defaults to 'asc' if SortOrder is null or invalid.
     */
    function OrderParameter(element, sortOrder) {
      _classCallCheck(this, OrderParameter);

      this.element = element;
      this.sortOrder = sortOrder;

      if (!element) {
        throw Error("Element specified in 'OrderParameter' is null or empty");
      }
    }

    _createClass(OrderParameter, [{
      key: "getParam",
      value: function getParam() {
        return "order=".concat(this.getParamValue());
      }
    }, {
      key: "getParamValue",
      value: function getParamValue() {
        return "".concat(this.element.trim(), "[").concat(this.sortOrder, "]");
      }
    }]);

    return OrderParameter;
  }();

  Parameters.OrderParameter = OrderParameter;

  var CustomParameter =
  /*#__PURE__*/
  function () {
    function CustomParameter(param) {
      _classCallCheck(this, CustomParameter);

      this.param = param;
    }

    _createClass(CustomParameter, [{
      key: "getParam",
      value: function getParam() {
        return this.param;
      }
    }]);

    return CustomParameter;
  }();

  Parameters.CustomParameter = CustomParameter;

  var DepthParameter =
  /*#__PURE__*/
  function () {
    /**
     * Configures the depth of the response. Content items might reference another 'linked items' using the Linked items element.
     * Recursively, these linked items can reference another linked items.
     * By default, only one level of linked content is returned.
     * @constructor
     * @param {number} depth - Depth fo the response
     */
    function DepthParameter(depth) {
      _classCallCheck(this, DepthParameter);

      this.depth = depth;

      if (depth < 0) {
        throw Error("'DepthParameter' must specify a positive integer or zero");
      }
    }

    _createClass(DepthParameter, [{
      key: "getParam",
      value: function getParam() {
        return "depth=".concat(this.depth);
      }
    }]);

    return DepthParameter;
  }();

  Parameters.DepthParameter = DepthParameter;

  var LanguageParameter =
  /*#__PURE__*/
  function () {
    /**
     * Specifies language version to fetch
     * @constructor
     * @param {string} languageCodename - Codename of the language
     */
    function LanguageParameter(languageCodename) {
      _classCallCheck(this, LanguageParameter);

      this.languageCodename = languageCodename;

      if (!languageCodename) {
        throw Error("'LanguageParameter' must specify codename of the language");
      }
    }

    _createClass(LanguageParameter, [{
      key: "getParam",
      value: function getParam() {
        return "language=".concat(this.languageCodename);
      }
    }]);

    return LanguageParameter;
  }();

  Parameters.LanguageParameter = LanguageParameter;
})(Parameters || (Parameters = {}));